import KitPairsSection from '@/sections/izzi/kit-pairs/kit-pairs-section';

export default function KitPairsPage() {
  return <KitPairsSection />;
}
